import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { getTenantRoutes } from './components/TenantRoutes';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import SuperAdminLogin from './pages/SuperAdminLogin';
import TenantLogin from './pages/TenantLogin';
import TenantRedirect from './pages/TenantRedirect';
import './styles/App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Rutas Super Administrador */}
          <Route path="/super-admin/login" element={<SuperAdminLogin />} />
          <Route path="/super-admin/dashboard" element={<SuperAdminDashboard />} />

          {/* Ruta /login sin código redirige a super admin */}
          <Route path="/login" element={<SuperAdminLogin />} />

          {/* Rutas Multi-Tenant - Login */}
          <Route path="/:codigo/login" element={<TenantLogin />} />

          {/* TODAS las rutas de Tenant con el código en la URL */}
          {getTenantRoutes()}

          {/* Ruta de redirección para /:codigo -> /:codigo/login */}
          <Route path="/:codigo" element={<TenantRedirect />} />

          {/* Ruta raíz redirige al login de super admin */}
          <Route path="/" element={<SuperAdminLogin />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
